module.exports = __webpack_public_path__ + "static/media/copy-gray.02d86607.svg";